import { FirstPage, NavigateBefore, NavigateNext, LastPage } from '@mui/icons-material';
import { PaginationItemProps, useTheme, Button } from '@mui/material';
import './style.css';

function PaginationButton({ type, disabled, selected, children, onClick }: PaginationItemProps){
  const { palette } = useTheme();

  const className = type;
  let buttonLabel = children;

  switch(type){
    case 'first':
      buttonLabel = <FirstPage/>
      break;
    case 'previous':
      buttonLabel = <NavigateBefore/>
      break;
    case 'next':
      buttonLabel = <NavigateNext/>
      break;
    case 'last':
      buttonLabel = <LastPage/>
      break;
    default:
      break;
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if(onClick && !disabled){
      onClick(e);
    };
  };

  return(
    <div onClick={handleButtonClick}>
      <Button
        className={className}
        variant='contained'
        disableElevation
        disabled={disabled}
        sx={{
          backgroundColor: selected ? palette.secondary.main : '#6c7373',
          '&:hover': { backgroundColor: selected ? palette.secondary.main : '#6c7373' },
        }}
      >
        {buttonLabel}
      </Button>
    </div>
  )
} export default PaginationButton;